import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { IGeofence } from '@app/interfaces/IGeofences';

@Directive({
    selector: 'veri-map-single-geofence'
})
export class VeriMapSingleGeofenceComponentFacade extends UpgradeComponent {
    @Input() geofence: IGeofence;

    constructor(elementRef: ElementRef, injector: Injector) {
        super('veriMapSingleGeofence', elementRef, injector);
    }
}
